module.exports = __webpack_public_path__ + "static/media/stofferingen-12.bfcc0493.jpg";